import React, {useState} from 'react'
import {connect} from 'react-redux'

import {
  Input, TabContainer, Select, Button,
  Icon,
  Switch,
} from '@lazarusai/forms-ui-components'

import {storePayload} from '../actions/storePayload.js'
import {submitVKGData} from '../actions/submitVKGData.js'

import stylesInput from '../styles/VKGInputForm.module.css'
import FileUpload from './FileUpload.js'

function VKGInputForm(props) {
  const [inputTab, setInputTab] = useState('create')
  const [selectedVKGId, setSelectedVKGId] = useState('')
  const [files, setFiles] = useState([])
  const [isParagraphSplit, setIsParagraphSplit] = useState(false)

  function clearForm() {
    setInputTab('create')
    setSelectedVKGId('')
    setFiles([])
  }

  return (
    <>
      <div
        className={`${stylesInput['url-section']}`}
      >
        <a
          key='vkg-ui'
          href={process.env.REACT_APP_VKG_UI}
          target={'_blank'}
          rel={'noopener noreferrer'}
        >
          VKG UI
        </a>
        <a
          key='vkg-chat'
          href={process.env.REACT_APP_VKG_CHAT}
          target={'_blank'}
          rel={'noopener noreferrer'}
        >
          VKG Chat
        </a>
      </div>
      <div
        className={`${stylesInput['form-body']}`}
      >
        <TabContainer
          theme={props.theme}
          activeTab={inputTab}
          canChangeTab={() => true}
          onTabChange={(tabName) => {
            setSelectedVKGId('')
            setInputTab(tabName)
          }}
          tabContent={{
            'create': {
              title: 'Create New VKG',
              render: (<></>),
            },
            'add': {
              title: 'Add Data to VKG',
              render: (<></>),
            },
          }}
        />
        <div
          className={`${stylesInput['form-body-row']}`}
        >
          {inputTab === 'create' ?
          <Input
            theme={props.theme}
            value={selectedVKGId}
            onChange={(e) => {
              setSelectedVKGId(e.target.value)
            }}
            label={'VKG ID'}
            placeholder={'New VKG ID'}
          /> :
          <Select
            onClickOption={(selectOption) => {
              setSelectedVKGId(selectOption)
            }}
            label={'VKG ID'}
            value={selectedVKGId}
            theme={props.theme}
            options={Object.keys(props.graphList || {'Loading VKGs...': ''})
                .sort()}
          />
          }
        </div>
        <div
          className={`${stylesInput['form-body-row']}`}
        >
          <FileUpload
            onChangeFile={async (e) => {
              const uploadedFiles =
              await e?.target?.files?.length ?
                e?.target?.files :
                  e?.dataTransfer?.files?.length ?
                    e?.dataTransfer?.files :
                      null
              const validFiles = Array.from(uploadedFiles).filter((fileObj) => {
                const extensionStart = fileObj.name.lastIndexOf('.')
                const fileExtension = fileObj.name.substring(
                extensionStart >= 0 ? extensionStart : 0,
                )
                const isFileExtensionGood = [
                  '.png', '.jpg', '.jpeg', '.tiff', '.tif', '.heic', '.pdf',
                ].includes(fileExtension)
                return isFileExtensionGood
              })
              setFiles([...files, ...validFiles])
            }}
          />
        </div>
        {(files?.length > 0) && <div
          className={`${
            stylesInput['form-body-row']
          } ${
            stylesInput['files-section']
          }`}
        >
        File List:
          {files.map((fileObj) => {
            return (
              <div
                key={fileObj.name}
                className={`${stylesInput['files-section-row']}`}
              >
                <div>{fileObj.name}</div>
                <div
                  onClick={() => {
                    setFiles(files.filter((fileObject) => {
                      return fileObject.name !== fileObj.name
                    }))
                  }}
                >
                  <Icon
                    icon='close-outline'
                  />
                </div>
              </div>
            )
          })}
        </div>}
        <div
          className={`${
            stylesInput['form-body-row']
          }`}
        >
          <Switch
            theme={props.theme}
            label={
            // eslint-disable-next-line max-len
              `Split Text By Paragraph [Default is Page Split] (Only for English languages for now)`
            }
            checked={isParagraphSplit}
            onChange={(e) => {
              setIsParagraphSplit(e.target.checked)
            }}
            info
          />
        </div>
        <footer
          className={`${stylesInput['form-body-row']}`}
        >
          <Button
            theme={props.theme}
            text={(
            inputTab === 'create' &&
            Object.keys(props.graphList || {}).includes(selectedVKGId)
          ) ? 'New VKG ID must not already exist': 'Submit'}
            disabled={(
              inputTab === 'create' &&
            Object.keys(props.graphList || {}).includes(selectedVKGId)
            ) || (!files.length) || !selectedVKGId.length}
            onClick={() => {
              props.submitVKGData(
                  selectedVKGId, files, inputTab === 'create', isParagraphSplit,
              )
            }}
          />
          <Button
            theme={props.theme}
            type={10}
            text={'Clear'}
            onClick={clearForm}
          />
        </footer>
      </div>
    </>
  )
}

const mapStateToProps = (state) => ({
  theme: state.userReducer.theme,
  graphList: state.userReducer.graphList,
  userId: state.userReducer.userId,
  authForm: state.userReducer.authForm,
})

export default connect(mapStateToProps, {
  storePayload, submitVKGData,
})(VKGInputForm)
